import { Pipe, PipeTransform } from '@angular/core';
import { toString } from 'lodash';

/**
 @deprecated use toStringPipe instead
  */
@Pipe({
  name: 'string',
  standalone: true,
})
export class StringPipe implements PipeTransform {
  public transform(value: unknown): string {
    return toString(value);
  }
}
